<base-table-layout
  [records]="grid"
  [footer]="footer"
  [gridActions]="gridActions"
  [hasRowCheckbox]="hasRowCheckbox"
  [settings]="columnSetting"
  [searched]="searched"
  [loading]="loading"
  [downloading]="downloading"
  [checkboxLoading]="checkboxLoading"
  [count]="count"
  [visuals]="visuals"
  [genericVisuals]="genericVisuals"
  (outputMethodHandler)="outputMethodHandler($event)"
  [sortNum]="sortNum"
  [sortDir]="sortDir"
  [secSortNum]="secSortNum"
  [secSortDir]="secSortDir"
  (changeSortHandler)="changeSort($event)"
  [pageSize]="pageSize"
  [pageNum]="pageNum"
  [pageMax]="pageMax"
  (changePageHandler)="changePage($event)"
  (changePageSizeHandler)="changePageSize($event)">
</base-table-layout>


<div bsModal #confirmModal="bs-modal" [config]="{backdrop: 'static'}" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div>
        <div class="modal-header">
          <h4 class="modal-title pull-left"></h4>
          <button type="button" class="close pull-right" aria-label="Close" (click)="confirmModal.hide();">
            <span aria-hidden="true">
              <i class="fa fa-close"></i>
            </span>
          </button>
        </div>
        <div class="modal-body">
          <div class="card card-accent-primary shadowed">
            <div class="card-block">
              <ng-container #dynamicComponentContainer></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  bsModal
  #rejectModal="bs-modal"
  [config]="{backdrop: 'static'}"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left"></h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="rejectModal.hide(); rejectionForm.reset()"
        >
          <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
      </div>
      <div class="modal-body card-block">
        <div class="card card-accent-primary shadowed">
          <div class="card-header">
            <strong>{{genericVisuals.enterRejectionReason}}</strong>
          </div>
          <div class="card-block">
            <ng-container *ngTemplateOutlet="formContent"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #formContent>
  <form [formGroup]="rejectionForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label class="input-required" for="rejectionReason">{{genericVisuals.rejectionReason}}</label>
      <textarea
        id="rejectionReason"
        [ngClass]="{'errorField': rejectionForm.controls.rejectionReason.invalid && rejectionForm.controls.rejectionReason.touched}"
        class="form-control"
        rows="5"
        formControlName="rejectionReason"
      ></textarea>
      <div
        class="error"
        *ngIf="isSubmitted && rejectionForm.controls['rejectionReason'].errors?.required"
      >
        {{genericVisuals.required}}
      </div>
      <div
        class="error"
        *ngIf="isSubmitted && rejectionForm.controls['rejectionReason'].errors?.maxlength"
      >
       {{genericVisuals.maxCharLength}} 250
      </div>
    </div>
    <div style="text-align: center;">
      <button type="submit" class="btn btn-success">{{ genericVisuals.submit }}</button>
    </div>
  </form>
</ng-template>